module.exports = __webpack_public_path__ + "static/img/app-store.6e5612e4.svg";